export const useShowModalClose = (): boolean => false;
